/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

import { React, useState, useEffect } from "react";

import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Modal, Drawer, AppBar, ListItemAvatar, Avatar, Toolbar, Typography, TextField, Button, Paper, List, ListItem, ListItemText } from "@mui/material";
import OrganizationCard from "./components/organizationcard";
import OrganizationForm from "./components/organizationform";
import {
  saveOrganizations,
  deleteOrganization,
  getOrganizations
} from "context";

const drawerWidth = 240;


function Organization() {
  const [open, setOpen] = useState(false);
  const [orgs , setorgs] = useState([]);
  const handleOpen = () => {
    setOpen(true)
    setorg(null);
  }
  const handleClose = () => setOpen(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [org, setorg] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  useEffect(() => {
    FetchOrg()
  }, [])
  const FetchOrg =  async () => {
    let resp = await getOrganizations();
    setorgs(resp.data.resp)
  }
  const editForm = (org) => {
    setorg(org);
    setOpen(true);
  }
  // const handleDelete = (org) => {
  //   alert("sss")
  // }
  
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
 const handleEdit = () => {
    handleMenuClose();
    onEdit();
  };

  // const handleDelete = () => {
  //   handleMenuClose();
  //   onDelete();
  // };





  const handleSave = async (organizationData) => {
    // Call saveOrganizations and refresh data
    await saveOrganizations(organizationData);
    FetchOrg(); // Refresh after save
    handleClose();
  };

  const handleDelete = async (orgId) => {
    // Call deleteOrganization and refresh data
    await deleteOrganization(orgId);
    FetchOrg(); // Refresh after delete
  };



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <Grid spacing={12} sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}>
          <MDButton color={"info"} onClick={handleOpen} >ADD new </MDButton>
        </Grid>
      </MDBox>
      <MDBox sx={{ minHeight:"75vh"  }}>
        <Grid container spacing={3} mt={1}>
        {
            orgs.map((value) => (
                <Grid item xs={3} key={value.id} >
                  <OrganizationCard
                    org={value}
                    editformData={editForm}
                    deleteOrganization={() => handleDelete(value)}
                  />
                </Grid>
            )
            )
          }
          
        </Grid>
      </MDBox>


      <Modal open={open} onClose={handleClose}>
        <OrganizationForm orgData={org}  saveOrganizations={handleSave} />
      </Modal>
      <Footer />
    </DashboardLayout>
  );
}

export default Organization;
